<template>
<update-base :stakeholder_type="stakeholder_type">
    <form @submit.prevent="submit_form()" id="update_status_form">
        <div class="row">
            <div class="col-12 col-md-6 my-2">
                <label for="status" v-text="$t('label.status')"></label>
                <select id="status"
                        name="status"
                        class="form-control"
                        v-model="form_data.status">
                    <option v-for="(item, index) in stakeholder_status"
                            :key="index"
                            :value="item"
                            v-text="stakeholder_status_str.get(item)"
                    >
                    </option>
                </select>
            </div>
        </div>
        <div class="mt-4 mb-2">
            <button type="submit" class="btn btn-success" v-text="$t('btn.update')"></button>
        </div>
    </form>
</update-base>
</template>

<script>
import UpdateBase from './components/update-base';
import $ from 'jquery';
import { stakeholdersService } from '@/common/api.service';
import { stakeholderStatus, stakeholderStatusStr } from '@/constants/stakeholderStatus';

export default {
    components: {
        UpdateBase,
    },
    data() {
        return {
            form_data: {},
            stakeholder_status: stakeholderStatus,
            stakeholder_status_str: stakeholderStatusStr,
        };
    },
    computed: {
        stakeholder_type() {
            return this.$route.params.stakeholder_type;
        }
    },
    mounted() {
        stakeholdersService.get_status(this.$route.params.hashid).then(response => {
            this.form_data = response.data.data;
        });
    },
    methods: {
        submit_form() {
            let form = $('#update_status_form');

            form.validate({
                rules: {
                    status: {
                        required: true,
                    },
                }
            });

            if (!form.valid()) {
                return;
            }

            let params = {
                status: this.form_data.status,
            };

            stakeholdersService.update_status(params, this.$route.params.hashid).then(response => {
                this.$router.push('/stakeholders');
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data);
                }

                this.showMsg(form, 'danger', response.data.message);
            });
        },
    },
}
</script>
